import type { WizardValuesBase } from '@/context/wizard/types';
import { UserFeedback } from '@/data/guidance/feedback/interfaces';
import type {
  RecommendationPlanIds,
  RecommendedPlanActivity,
} from '@/data/idp/profile-based-recommendations/interfaces';
import type { Skill } from '@/models/taxonomy/skills';

export enum FeedbackOptions {
  Current = 'current',
  New = 'new',
  Skip = 'skip',
}

interface RecommendationReviewProps {
  recommended_activities: RecommendedPlanActivity[] | null;
  recommended_plan_description: string;
}

interface FeedbackProps {
  currentFeedback?: UserFeedback | null;
  option: FeedbackOptions | null;
}

export interface CreatePlanWizardValues extends WizardValuesBase {
  id: string;
  planId: string;
  [RecommendationPlanIds.Duration]: number | null;
  [RecommendationPlanIds.Feedback]: FeedbackProps | null;
  [RecommendationPlanIds.NewFeedback]: string | null;
  [RecommendationPlanIds.ProcessingFeedback]: { feedbackId: number } | null;
  [RecommendationPlanIds.SkillSelection]: Skill[] | null;
  [RecommendationPlanIds.RecommendationReview]: RecommendationReviewProps | null;
}
